import type { IRulePagesWrapper } from "app/pages/segments/redesigned-wizard/segment-wizard/types";
import { RuleTypes } from "app/pages/segments/redesigned-wizard/segment-wizard/types";
import type { FC } from "react";
import { PagesWrapper } from "app/pages/segments/redesigned-wizard/segment-wizard/segment-rules-section/PagesWrapper";
import { i18nFilter } from "app/filters/i18nFilter";
import {
    BoldSpan,
    CircleSeparator,
    PagesSeparatorWrapper,
    SeparatorTextSpan,
} from "app/pages/segments/redesigned-wizard/segment-wizard/styledComponents";
import { doesAtLeastOneRuleExist } from "app/pages/segments/redesigned-wizard/segment-wizard/segmentWizardHelpers";

export const RulePagesWrapper: FC<IRulePagesWrapper> = (props) => {
    const {
        segmentIncludeRules,
        segmentExcludeRules,
        isMidTierUser,
        onCloseRule,
        domain,
        getUrlsPreview,
        hideUrlsPreview,
        hasExistingUrlsCompoundStringNoRobots,
        updateWordPredictionsIfNeeded,
        isMidtierUserAndOneRuleCreated,
        resetActiveIndex,
    } = props;

    const pagesWrapperProps = {
        isMidtierUserAndOneRuleCreated,
        isMidTierUser,
        domain,
        getUrlsPreview,
        hideUrlsPreview,
        hasExistingUrlsCompoundStringNoRobots,
        updateWordPredictionsIfNeeded,
        onCloseRule,
        resetActiveIndex,
    };

    return (
        <>
            <PagesWrapper
                key={`pagesWrapper_${RuleTypes.include}`}
                rules={segmentIncludeRules}
                title={i18nFilter()("segmentsWizard.includePages.title")}
                ruleType={RuleTypes.include}
                doExcludeRulesExist={doesAtLeastOneRuleExist(segmentExcludeRules[0])}
                {...pagesWrapperProps}
            />
            <PagesSeparatorWrapper>
                <BoldSpan>{i18nFilter()("segmentsWizard.addFilters.and.label")}</BoldSpan>
                <CircleSeparator />
                <SeparatorTextSpan>{i18nFilter()("segmentsWizard.addFilters.separator.label")}</SeparatorTextSpan>
            </PagesSeparatorWrapper>
            <PagesWrapper
                key={`pagesWrapper_${RuleTypes.exclude}`}
                rules={segmentExcludeRules}
                title={i18nFilter()("segmentsWizard.excludePages.title")}
                ruleType={RuleTypes.exclude}
                {...pagesWrapperProps}
            />
        </>
    );
};
